"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var e=!1;exports.isPure=e;
